import React from "react";
import "./AISectionn.css";

const BrainIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
    <path d="M32 8C24 8 18 14 18 22c0 3 1 6 3 8-2 1-4 4-4 7 0 4 3 7 7 8v3h16v-3c4-1 7-4 7-8 0-3-2-6-4-7 2-2 3-5 3-8 0-8-6-14-14-14z" stroke="#D4A847" strokeWidth="2" fill="none" />
    <line x1="32" y1="22" x2="32" y2="45" stroke="#D4A847" strokeWidth="1.5" />
    <line x1="24" y1="28" x2="40" y2="28" stroke="#D4A847" strokeWidth="1.5" />
    <line x1="24" y1="35" x2="40" y2="35" stroke="#D4A847" strokeWidth="1.5" />
    <circle cx="24" cy="22" r="2" fill="#D4A847" />
    <circle cx="40" cy="22" r="2" fill="#D4A847" />
    <circle cx="20" cy="32" r="2" fill="#D4A847" />
    <circle cx="44" cy="32" r="2" fill="#D4A847" />
    <line x1="22" y1="22" x2="26" y2="22" stroke="#D4A847" strokeWidth="1.5" />
    <line x1="38" y1="22" x2="42" y2="22" stroke="#D4A847" strokeWidth="1.5" />
    <line x1="20" y1="30" x2="24" y2="28" stroke="#D4A847" strokeWidth="1.5" />
    <line x1="44" y1="30" x2="40" y2="28" stroke="#D4A847" strokeWidth="1.5" />
  </svg>
);

const RocketIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
    <path d="M32 8C32 8 20 20 20 34c0 4 2 8 5 10l7 7 7-7c3-2 5-6 5-10C44 20 32 8 32 8z" stroke="#D4A847" strokeWidth="2.2" fill="none" />
    <circle cx="32" cy="28" r="4" stroke="#D4A847" strokeWidth="2" fill="none" />
    <path d="M24 42l-6 6M40 42l6 6" stroke="#D4A847" strokeWidth="2" strokeLinecap="round" />
    <path d="M26 46c0 4 2 8 6 10 4-2 6-6 6-10" stroke="#D4A847" strokeWidth="1.5" fill="none" />
  </svg>
);

const ChartIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
    <rect x="10" y="36" width="10" height="18" rx="2" stroke="#D4A847" strokeWidth="2" fill="none" />
    <rect x="27" y="24" width="10" height="30" rx="2" stroke="#D4A847" strokeWidth="2" fill="none" />
    <rect x="44" y="14" width="10" height="40" rx="2" stroke="#D4A847" strokeWidth="2" fill="none" />
    <path d="M15 30l12-10 12 6 10-14" stroke="#D4A847" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="49" cy="12" r="3" fill="#D4A847" />
  </svg>
);

const BuildingIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
    <rect x="16" y="14" width="32" height="40" rx="2" stroke="#D4A847" strokeWidth="2" fill="none" />
    <rect x="24" y="22" width="6" height="6" rx="1" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <rect x="34" y="22" width="6" height="6" rx="1" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <rect x="24" y="34" width="6" height="6" rx="1" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <rect x="34" y="34" width="6" height="6" rx="1" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <path d="M27 54V46h10v8" stroke="#D4A847" strokeWidth="1.5" />
    <path d="M8 54h48" stroke="#D4A847" strokeWidth="2" strokeLinecap="round" />
    <rect x="20" y="8" width="24" height="8" rx="1" stroke="#D4A847" strokeWidth="1.5" fill="none" />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
    <circle cx="32" cy="18" r="8" stroke="#D4A847" strokeWidth="2" fill="none" />
    <path d="M16 50c0-9 7-16 16-16s16 7 16 16" stroke="#D4A847" strokeWidth="2" strokeLinecap="round" fill="none" />
    <circle cx="14" cy="22" r="5" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <path d="M4 48c0-6 4-10 10-10" stroke="#D4A847" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    <circle cx="50" cy="22" r="5" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <path d="M60 48c0-6-4-10-10-10" stroke="#D4A847" strokeWidth="1.5" strokeLinecap="round" fill="none" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
    <circle cx="10" cy="10" r="9" stroke="#D4A847" strokeWidth="1.5" fill="none" />
    <path d="M6 10l3 3 5-5" stroke="#D4A847" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowRight = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const segments = [
  {
    icon: <RocketIcon />,
    title: "Startup Founders",
    desc: "Build faster, scale smarter, and validate ideas with AI-driven execution.",
  },
  {
    icon: <ChartIcon />,
    title: "SMEs & Growing Businesses",
    desc: "Optimize operations, reduce costs, and unlock efficiency through automation.",
  },
  {
    icon: <BuildingIcon />,
    title: "Large Enterprises",
    desc: "Drive large-scale transformation with aligned strategy, systems, and execution.",
  },
  {
    icon: <PeopleIcon />,
    title: "Industry Leaders",
    desc: "Apply AI where it creates real competitive advantage — not just experimentation.",
  },
];

export default function AISection() {
  return (

    <section className="aii-sec">
      <div className="aii-page">
        {/* Banner */}
        <div className="ai-banner">
          <div className="ai-banner__icon-wrap">
            <BrainIcon />
          </div>
          <div className="ai-banner__text">
            <h2 className="ai-banner__heading">Not sure where to start with AI?</h2>
            <p className="ai-banner__sub">
              Get a clear, data-driven view of your organization's AI readiness in minutes.
            </p>
          </div>
          <ul className="ai-banner__checks">
            {["Identify gaps", "Discover high-impact opportunities", "Get a practical transformation roadmap"].map((item) => (
              <li key={item} className="ai-banner__check-item">
                <CheckIcon />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <a href="/impact/ai-readiness">
            <button className="ai-banner__cta">
              Get Your AI Readiness Score &nbsp;<ArrowRight />
            </button>
          </a>

        </div>

        {/* Who We Help */}
        <div className="ai-who">
          <h2 className="ai-who__title">Who We Help</h2>
          <div className="ai-who__underline" />
          <p className="ai-who__sub">
            We work with leaders across different stages of growth — each with unique challenges and goals.
          </p>
          <div className="ai-who__grid">
            {segments.map((s) => (
              <div className="ai-card" key={s.title}>
                <div className="ai-card__icon-wrap">{s.icon}</div>
                <h3 className="ai-card__title">{s.title}</h3>
                <p className="ai-card__desc">{s.desc}</p>
                <a href="#" className="ai-card__link">
                  Learn More &nbsp;<ArrowRight />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}